import React from "react";
import { connect } from "react-redux";
import Rdx from "../../../redux/Rdx";

import Book from "./Book";
import Context from "../../../context/Context";
import DropdownButton from "../../../components/common/Dropdown/DropdownButton";
import Button from "../../../common/components/Button/Button";
import Filter from "./Filter";
import Icons from "../../util/Icons";
import MeetingRoomsModel from "./MeetingRoomsModel";
import ModalController from "../../../common/components/Modal/ModalController";
import SidebarHeader from "../Sidebar/SidebarHeader";
import Topic from "../../../context/Topic";
import When from "./When";

import * as meetingRoomUtil from "./MeetingRoomUtil";
import * as component from "../../util/component";
import * as dateUtil from "../Events/dateUtil";
import { hideReservationsByFilter } from "../More/Actions/BookWorkspace/WorkspaceReservation/reservationsLayerUtil";

import Loader from "calcite-react/Loader/Loader";
import ClockIcon from "calcite-ui-icons-react/ClockIcon";
import FilterIcon from "calcite-ui-icons-react/FilterIcon";
import SortAscIcon from "calcite-ui-icons-react/SortAscendingArrowIcon";
import SortDescIcon from "calcite-ui-icons-react/SortDescendingArrowIcon";
import MyMeetingRooms from "./MyMeetingRooms";
import MyMeetingRoomsOffice365 from "./MyMeetingRoomsOffice365";
import { getMeetingBookingSystem, getMeetingBookingSystemType } from "../More/Actions/BookWorkspace/WorkspaceReservation/workspaceReservationUtil";
import * as validateUtil from "../More/Actions/BookWorkspace/validateUtil";
import BookingDateFilter from "../Events/BookingDateFilter";


const CSS = {
  meetingRoomScroll: "i-scroll-meeting-rooms",
  optionsContainer: "i-events-options-container",
  options: "i-events-options",
  meetingTabs: "i-meeting-tabs",
  meetingTab: "i-meeting-tab",
  filterButton: "i-filter-button",
  ddButton: "i-dd-button",
  dateLabel: "i-events-options-label"
}

const TABS = {
  available: "available",
  booked: "booked"
};

class MeetingRooms extends React.Component {

  model;
  _mounted = false;

  constructor(props) {
    super(props);
    this._componentId = component.nextId("meeting-rooms-");
    this.model = new MeetingRoomsModel({parentComponent: this});
    this.state = component.newState({
      criteriaString: null,
      items: null,
      filteredItems: null,
      reservedUnits: null,
      working: true,
      wasSiteInit: false,
      activeTab: TABS.available,
      bookingDateFilter: null
    });

    // Reset default duration and filters every time hotel/meetings panel opens #4652
    Context.instance.session.meetingRoomsCriteria = null

    this.getCriteria();
  }

  componentDidMount() {
    this._mounted = true;
    this.model.queryUnits();

    component.own(this,[

      Topic.subscribe(Topic.ReloadViews,params => {
        try {
          Context.instance.session.meetingRoomsCriteria = null;
          this.setState(state => {
            return {
              abandon: true
            };
          });
        } catch(ex) {
          console.error(ex);
        }
      }),

      Topic.subscribe(Topic.ReservationsUpdated,params => {
        this.executeTask("queryReservations");
      }),

      Topic.subscribe(Topic.MeetingRoomsFilterClear, ()=> {
        this.filterClicked();
      })

    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
    Context.instance.session.sharedMeetingRoomWhen = null;
    Rdx.setValue(this,Rdx.Keys.BOOK_DATEFILTER_OPTION,'any');
  }

  _initSite =()=> {
    const criteria = this.getCriteria();
    if(criteria && criteria.wasSiteInitialised) {
      this.model.queryUnits();
    }else {
      meetingRoomUtil.getSiteId()
      .then((activeSiteId)=>{
        if(activeSiteId) {
          let hasSiteFacility = false;
          const levelsDataset = Context.instance.aiim.datasets.levels;
          const facilities = levelsDataset && levelsDataset.getFacilities();
          facilities.forEach(facility => {
            if(facility.siteId === activeSiteId) hasSiteFacility = true;
          })
          if(!hasSiteFacility) criteria.filter.siteId = null;
          else criteria.filter.siteId = activeSiteId;
        }
        criteria.wasSiteInitialised = true;
      })
      .then(()=> {
        this.model.queryUnits();
      })
      .catch(error => {
        console.warn("Error querying units for selected site: MeetingRooms", error);
        console.error(error);
      })
    }
  }

  backClicked = () => {
    hideReservationsByFilter();
    Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY, "more");
    document.body.classList.add("i-sidebar-panel-open");
    Topic.publish(Topic.SidebarButtonClicked,{sidebarKey: "more"});
    Context.instance.views.toggleClickHandlers("resume");
  }

  processBookClick = true;

  bookClicked = async(item) => {
    if (!this.processBookClick) return;
    try {
      this.processBookClick = false;
      let criteria = JSON.parse(JSON.stringify(this.getCriteria())); 
      const when = criteria.when;
      const bookingSystem = getMeetingBookingSystem();
      const task = {
        bookingType: 'meetingRooms',
        checkInDate: new Date(when.start.date),
        checkOutDate: new Date(when.end.date),
        allDay: (when.duration === "allDay"),
        unit: item.feature,
        unitName: item.name,
        scheduleEmail: item.scheduleEmail,
        bookingSystem: bookingSystem
      }
       
      const response = await validateUtil.verify(task);
      if (response && response.ok) {
        let showInfo = {
          bookItem: item,
          criteria: criteria
        }
        Book.show(showInfo);
      }
    } finally {
      setTimeout(()=> {
        this.processBookClick = true;
      },200)
    }
  }

  executeTask(type) {
    this.model.executeTask(type);
  }

  actionBar =()=> {
    let info;
    info = {
      applyButton: null,
      applyButtonClicked: null,
      clearAllButton: null,
      clearAllButtonClicked: null,
    }
    const i18n = Context.instance.i18n;

    let btnApply = (
      <Button key="modal-assign" className="i-apply-button" gapRight
        onClick={evt => {
          if (info.applyButtonClicked) info.applyButtonClicked(evt)
        }}
        _onMount={obj => {
          info.applyButton = obj
        }}>
        {i18n.more.bookWorkspace.apply}
      </Button>
    )
    let btnClearAll = (
      <Button key="modal-cancel" className="i-clearAll-button" clear gapRight
        onClick={evt => {
          if (info.clearAllButtonClicked) info.clearAllButtonClicked(evt)
        }}
        _onMount={obj => {
          info.clearAllButton = obj
        }}>
        {i18n.more.bookWorkspace.clearAll}
      </Button>
    )

    info.content = (
      <div style={{width: "100%"}}>
        {btnClearAll}
        {btnApply}
      </div>
    )
    return info;
  }

  filterClicked = () => {
    const i18n = Context.instance.i18n;
    let criteria = this.getCriteria();
    let actionBarInfo = this.actionBar();
    const actionBarContent = actionBarInfo.content;
    let filterComponent;
    const controller = new ModalController();

    actionBarInfo.applyButtonClicked = () => {
      let newCriteria = {};
      let ok = filterComponent.validate(newCriteria)
      if (ok) {
        criteria.filter = newCriteria.filter;
        this.executeTask("filterUnits");
        controller.close();
      }
    }
    actionBarInfo.clearAllButtonClicked = () => {
      criteria.filter = {
        siteId: null,
        facilityId: null,
        levelId: null,
        capacity: null,
        equipments: []
      };
      controller.close();
      Topic.publish(Topic.MeetingRoomsFilterClear, {});
    }

    const modalProps = {
      className: 'i-modal-confirm',
      title: i18n.meetingRooms.filter,
      showOKCancel: false,
      actionBarContent: actionBarContent
    };

    const content = (
      <Filter criteria={criteria} items={this.state.items}
        onMount={c => filterComponent = c} />
    )
    controller.show(modalProps,content);
  }

  getCriteria() {
    return this.model.getCriteria();
  }

  itemClicked = (item) => {
    const source = Context.instance.aiim.datasets.units.getSource();
    const feature = item.feature;
    const searchResult = source.makeSearchResult(null, feature);
    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      isMeetingRoomsPanel: true,
      componentId: this._componentId
    })
  }

  tabClicked = (event) => {
    const type = event.target.getAttribute("data-tabtype");
    this.setState({
      activeTab: type
    });
  }

  renderTabs() {
    const i18n = Context.instance.i18n;
    return (
      <div className={CSS.meetingTabs}>
        {this.renderTab(i18n.more.bookWorkspace.tabs.available, TABS.available)}
        {this.renderTab(i18n.more.bookWorkspace.tabs.booked, TABS.booked)}
      </div>
    );
  }

  renderTab(title, type) {
    const { activeTab } = this.state;
    const active = type === activeTab;
    const cls = active ? `${CSS.meetingTab} i--active` : `${CSS.meetingTab} i--inactive`;
    return (
      <button
        className={cls}
        role="tab"
        aria-selected={active ? "true" : "false"}
        data-tabtype={type}
        onClick={this.tabClicked}
      >
        {title}
      </button>
    );
  }

  renderWorking() {
    return ( <Loader sizeRatio={1} style={{marginTop: "3rem"}} /> )
  }

  render() {
    if (this.state.abandon) return null;
    return (
      <div className={"i-meeting-rooms"}>
        {this.renderHeader()}
        {this.renderTabs()}
        <div className={"i-meeting-rooms-content"}>
          <div className={"i-scroll-meeting-rooms i--tabs"}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const { activeTab } = this.state;

    switch (activeTab) {
      case TABS.booked:
        return this.renderBooked();
      case TABS.available:
      default:
        return this.renderAvailable();
    }
  }

  renderAvailable() {
    const options = this.renderOptions();
    const cs = this.renderCriteriaString();
    const items = this.renderItems();
    return (
      <>
        {options}
        {cs}
        {items}
      </>
    );
  }
  renderDateLabel() {
    const { bookingDateFilter } = this.state;
    const { criteria } = bookingDateFilter || {};
    if (!(criteria && criteria.dateOption)) {
      return null;
    }
    const date = dateUtil.formatDateFilter(bookingDateFilter);
    return (
      <div className={CSS.dateLabel}>{date}</div>
    );
  }
  renderBooked() {
    const bookingSysType = getMeetingBookingSystemType();
    const bookingSystem = getMeetingBookingSystem();
    
    const dateFilter = (
      <div className={CSS.optionsContainer}>
        <BookingDateFilter type='bookings' onFilterChange={data =>
          this.setState({ bookingDateFilter: data })} />
        {this.renderRefresh()}
        {this.renderDateLabel()}
      </div>
    )

    if (bookingSysType === "office365") {
      return (
        <>
          {dateFilter}
          <MyMeetingRoomsOffice365 bookingDateFilter={this.state.bookingDateFilter} bookingSystem={bookingSystem}/>
        </>
      )
    } else {
      return (
        <>
          {dateFilter}
          <MyMeetingRooms bookingDateFilter={this.state.bookingDateFilter}/>
        </>
      );
    }
  }

  renderCriteriaString() {
    let criteriaString = this.state.criteriaString || " ";
    return (
      <div className={"i-separated-left-right i-font-size-s"}>
       {criteriaString}
      </div>
    );
  }

  renderHeader() {
    const i18n = Context.instance.i18n;
    return (
      <SidebarHeader
        caption={i18n.meetingRooms.caption}
        closeAriaLabel={i18n.events.closeAriaLabel}
        sidebarKey={this.props.sidebarKey}
        showBack={!!this.props.morePanel}
        backHandler={this.backClicked}
      />
    );
  }

  renderItem(item, idx) {
    const clicked = () => {
      this.itemClicked(item);
    };
    const bookClicked = (evt) => {
      evt.stopPropagation(true);
      this.bookClicked(item);
    };
    const pinIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#pin-16";
    const groupIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#group-16";
    const i18n = Context.instance.i18n;
    let cap;
    if (typeof item.capacity === "number") {
      cap = i18n.meetingRooms.capacityPattern.replace("{num}",item.capacity);
    }
    return (
      <div key={"oid" + item.oid} className={"i-available-unit"} tabIndex={idx}
        onClick={clicked}>
        <div className="i-flex-between">
          <div>
            <div className={"i-title i-overflow-wrap-anywhere"}>{item.name}</div>
            <div key="fl" className={"i-unit-info"}>
              <svg><use href={pinIcon}></use></svg>
              <div>{item.sfl && item.sfl.facilityLevel}</div>
            </div>
            {typeof item.capacity === "number" && (
              <div key="cap" className={"i-unit-info"}>
                <svg><use href={groupIcon}></use></svg>
                <div>{cap}</div>
              </div>
            )}
          </div>
          <div>
            <button className="i-button i-button-clear i-nowrap i-fill-brand-color"
              onClick={bookClicked}>
              {Icons.conferenceRoom()}
              <span>{i18n.meetingRooms.book.label}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderItems() {
    const i18n = Context.instance.i18n;
    let working = !!this.state.working;
    let content;
    let items = this.state.filteredItems;
    if (working) {
      content = this.renderWorking();
    } else if (!items || items.length === 0) {
      content = (
        <div className="i-separated-left-right">
          {i18n.meetingRooms.noMatch}
        </div>
      )
    } else {
      content = items.map((item, idx) => {
        return this.renderItem(item, idx);
      });
    }
    return (
      <div className={"i-section i-scroll-items"}>
        {content}
      </div>
    );
  }

  renderOptions() {
    const i18n = Context.instance.i18n;
    const disabled = !!this.state.working;

    const setDuration = dur => {
      let c = this.getCriteria();
      c.when.duration = dur;
      if (dur !== "allDay") {
        let dtStart = new Date(c.when.start.date);
        let dtEnd = dateUtil.addDuration(dtStart,dur);
        c.when.end.date = dtEnd.getTime();
      }
      component.refresh(this);
      this.executeTask("queryReservations");
    };

    let criteria = this.getCriteria();
    let duration = criteria.when.duration;

    const getDurationClass = dur => {
      let cn = "i-dd-button";
      if (dur === duration) {
        cn += " i-highlighted";
      }
      return cn;
    }

    const refresh = () => {
      this.setState({
        working: true
      })
      this.model.queryUnits();
    }

    return (
      <div className="i-separated-top">
        <div className="i-events-options i-separated-left-right i-separated-bottom">
          <div className="i-filter-button">
            <button className="i-dd-button" onClick={this.whenClicked}
              disabled={disabled}
              aria-label={i18n.meetingRooms.whenAriaLabel}>
              <div className="i-flex-between-centered">
                <ClockIcon size="16"/>
                <span className="i--ml">{i18n.meetingRooms.when}</span>
              </div>
            </button>
          </div>
          <div className="i-filter-button">
            <button className="i-dd-button" onClick={this.filterClicked}
              disabled={disabled}
              aria-label={i18n.meetingRooms.filterAriaLabel}>
              <div className="i-flex-between-centered">
                <FilterIcon size="16"/>
                <span className="i--ml">{i18n.meetingRooms.filter}</span>
              </div>
            </button>
          </div>
          <div className="i-filter-button">
            {this.renderSort(disabled)}
          </div>
          <div className={CSS.filterButton + " i-refresh"}>
            <button title={i18n.more.bookWorkspace.refresh} disabled={disabled}
              aria-label={i18n.more.bookWorkspace.refreshAriaLabel} className={CSS.ddButton}
              onClick={refresh}>
              {Icons.reload()}
            </button>
          </div>
        </div>
        <div className="i-events-options i-separated-left-right i-separated-bottom">
          <div className="i-filter-button">
            <button className={getDurationClass("thirtyMin")}
              disabled={disabled}
              onClick={() => {
                setDuration("thirtyMin");
              }}
              aria-label={i18n.meetingRooms.durations.thirtyMinAriaLabel}>
              {i18n.meetingRooms.durations.thirtyMin}
            </button>
          </div>
          <div className="i-filter-button">
            <button className={getDurationClass("oneHour")}
              disabled={disabled}
              onClick={() => {
                setDuration("oneHour");
              }}
              aria-label={i18n.meetingRooms.durations.oneHourAriaLabel}>
              {i18n.meetingRooms.durations.oneHour}
            </button>
          </div>
          <div className="i-filter-button">
            <button className={getDurationClass("twoHours")}
              disabled={disabled}
              onClick={() => {
                setDuration("twoHours");
              }}
              aria-label={i18n.meetingRooms.durations.twoHoursAriaLabel}>
              {i18n.meetingRooms.durations.twoHours}
            </button>
          </div>
          <div className="i-filter-button">
            <button className={getDurationClass("allDay")}
              disabled={disabled}
              onClick={() => {
                setDuration("allDay");
              }}
              aria-label={i18n.meetingRooms.durations.allDayAriaLabel}>
              {i18n.meetingRooms.durations.allDay}
            </button>
          </div>
        </div>
      </div>
    );
  }

  refreshClicked = () => {
    const type = getMeetingBookingSystemType();
    if (type === "office365") Topic.publish(Topic.RenderMeetingListOffice365, {});
    else Topic.publish(Topic.RenderMeetingRooms, {});
  }

  renderRefresh() {
    const i18n = Context.instance.i18n;
    const disabled = !!this.state.working;

    return (
      <div key="datetime" className={CSS.options}>
        <div className={CSS.filterButton + " i-refresh"}>
          <button title={i18n.more.bookWorkspace.refresh} disabled={disabled}
            aria-label={i18n.more.bookWorkspace.refreshAriaLabel} className={CSS.ddButton}
            onClick={this.refreshClicked}>
            {Icons.reload()}
          </button>
        </div>
      </div>
    )
  }

  renderSort(disabled) {
    const i18n = Context.instance.i18n;

    const sort = opt => {
      setTimeout(() => {
        component.refresh(this);
        this.executeTask("sortUnits");
      },1);
    };

    const setSortBy = opt => {
      const c = this.getCriteria();
      if (c.sortBy !== opt) {
        c.sortDir = "asc";
      }
      c.sortBy = opt;
      sort();
    };

    const setSortDir = opt => {
      const c = this.getCriteria()
      c.sortDir = opt;
      sort();
    };

    let criteria = this.getCriteria();
    let sortBy = criteria.sortBy;
    let sortDir = criteria.sortDir;

    const getSortDirClass = opt => {
      let cn ="i-sorting-button";
      if (sortDir === opt) {
        cn += " i--active";
      }
      return cn;
    }

    const getSortIcon = () => {
      if (sortDir === "desc") {
        return <SortDescIcon size="16" />
      } else {
        return <SortAscIcon size="16" />
      }
    }

    const getIcon = opt => {
      let chk;
      if (sortBy === opt) {
        chk = (<span key="icon">{Icons.checkMark()}</span>);
      } else {
        chk = (<span key="icon" className="svg-icon i-icon-empty"></span>);
      }
      return chk;
    };

    let sortButton = (
      <div className="i-dd-button" disabled={disabled}
        aria-label={i18n.meetingRooms.sortAriaLabel}>
        <div className="i-flex-between-centered">
          {getSortIcon()}
          <span className="i--ml">{i18n.meetingRooms.sort}</span>
        </div>
      </div>
    );

    const sortOptions = [];

    sortOptions.push(
      <li key={"dir"} role="none" className="i-flex-between i-border-bottom">
        <div></div>
        <div className="i-sortby">
          <button type="button" className={getSortDirClass("asc")+" i--focusable"}
            title={i18n.meetingRooms.sortOptions.ascending}
            onClick={() => {
              setSortDir("asc");
            }}>
            {Icons.ascendingSort()}
          </button>
          <button type="button" className={getSortDirClass("desc")+" i--focusable"}
            disabled={sortBy === "distanceHome" || sortBy === "distanceBluedot"}
            title={i18n.meetingRooms.sortOptions.descending}
            onClick={() => {
              setSortDir("desc");
            }}>
            {Icons.descendingSort()}
          </button>
        </div>
      </li>
    );

    sortOptions.push(
      <li key={"name"} role="none" className="i-border-bottom">
        <button type="button" className="i-button-link i-padded i--focusable"
          onClick={() => {
            setSortBy("name");
          }}>
          {getIcon("name")}
          {i18n.meetingRooms.sortOptions.name}
        </button>
      </li>
    );
    if (this.model.canSortByCapacity()) {
      sortOptions.push(
        <li key={"capacity"} role="none" className="i-border-bottom">
          <button type="button" className="i-button-link i-padded i--focusable"
            onClick={() => {
              setSortBy("capacity");
            }}>
            {getIcon("capacity")}
            {i18n.meetingRooms.sortOptions.capacity}
          </button>
        </li>
      );
    }
    if (this.model.canSortByBluedotDistance()) {
      sortOptions.push(
        <li key={"distanceBluedot"} role="none">
          <button type="button" className="i-button-link i-padded i--focusable"
            onClick={() => {
              setSortBy("distanceBluedot");
            }}>
            {getIcon("distanceBluedot")}
            {i18n.meetingRooms.sortOptions.distanceBluedot}
          </button>
        </li>
      );
    }
    if (this.model.canSortByHomeDistance()) {
      sortOptions.push(
        <li key={"distanceHome"} role="none">
          <button type="button" className="i-button-link i-padded i--focusable"
            onClick={() => {
              setSortBy("distanceHome");
            }}>
            {getIcon("distanceHome")}
            {i18n.meetingRooms.sortOptions.distanceHome}
          </button>
        </li>
      );
    }

    let sortContent = (
      <ul className="i-padded" role="menu">{sortOptions}</ul>
    );

    if (disabled) sortContent = null;

    // className="i-dd-button"

    return (
      <DropdownButton
        closeOnSelect2={true}
        focusFirst={true}
        buttonClassName={"i-no-padding i-no-border"}
        buttonContent={sortButton}
        dropdownContent={sortContent}
        disabled={disabled}
        placement={"bottom-start"}>
      </DropdownButton>
    );
  }

  whenClicked = () => {
    const i18n = Context.instance.i18n;
    let criteria = this.getCriteria();
    let whenComponent;
    const controller = new ModalController();
    const modalProps = {
      className: "i-modal-confirm",
      title: i18n.meetingRooms.when,
      okLabel: i18n.general.done,
      showOKCancel: true,
      hideCancel: true,
      closeOnOK: false,
      onOK: () => {
        let newCriteria = {};
        let ok = whenComponent.validate(newCriteria)
        if (ok) {
          criteria.when = newCriteria.when;
          this.executeTask("queryReservations");
          controller.close();
        }
      }
    };
    const content = (
      <When criteria={criteria}
        onMount={c => whenComponent = c} />
    )
    controller.show(modalProps,content);
  }

}

const mapStateToProps = (state) => {
  return {
    //rdxDateOption: Rdx.getValue(state,Rdx.Keys.EVENTS_DATEFILTER_OPTION),
  }
}

export default connect(mapStateToProps)(MeetingRooms);
